import { Toaster } from 'sonner';

/**
 * Centralised toast provider using Sonner.
 * Mount once in App.tsx — all toasts are triggered via the useToast hook.
 *
 * Styling: unstyled mode with Tailwind classNames matching the app's Card design.
 * Position: bottom-center on all viewports (above BottomNav on mobile).
 */
export default function ToastProvider() {
  return (
    <Toaster
      position="bottom-center"
      offset={{ bottom: '5rem' }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4 flex items-center gap-3 w-full max-w-lg mx-auto',
          title: 'text-sm font-medium text-gray-900 dark:text-white',
          description: 'text-xs text-gray-500 dark:text-gray-400 mt-0.5',
          actionButton:
            'ml-auto shrink-0 px-3 py-1.5 text-sm font-medium rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors',
          cancelButton:
            'px-3 py-1.5 text-sm font-medium rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors',
          closeButton:
            'text-gray-400 hover:text-gray-600 dark:hover:text-gray-200',
          success: 'border-l-4 border-l-green-500',
          error: 'border-l-4 border-l-red-500',
          warning: 'border-l-4 border-l-yellow-500',
          info: 'border-l-4 border-l-blue-500',
        },
      }}
    />
  );
}
